// Toggle the menu open and close when on mobile.
// Multiple .gh-burger elements may exist (top-bar burger, overlay backdrop,
// overlay close X) — all of them toggle the shared body.gh-head-open class.
// ESC key also closes the overlay when open.
export default function menuOpen() {
    const burgers = document.querySelectorAll('.gh-burger');
    if (!burgers.length) return;

    const syncAria = (isOpen) => {
        burgers.forEach(b => b.setAttribute('aria-expanded', String(isOpen)));
    };

    burgers.forEach(btn => {
        btn.addEventListener('click', () => {
            const isOpen = document.body.classList.toggle('gh-head-open');
            syncAria(isOpen);
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('gh-head-open')) {
            document.body.classList.remove('gh-head-open');
            syncAria(false);
        }
    });
}